import { render, staticRenderFns } from "./DataProtectionDeclaration.vue?vue&type=template&id=f9ca8ec6"
import script from "./DataProtectionDeclaration.vue?vue&type=script&lang=ts"
export * from "./DataProtectionDeclaration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports